import { useEffect, useState } from 'react';

import { useAuthenticationDataContext } from '../../../Helpers/AuthenticationDataProvider';
import useFetchWrapper, {
	HttpResponse,
} from '../../../Helpers/useFetchWrapper';

import { CurrentUserResponse } from '../../../pages/EditCurrentProfile/EditCurrentProfile.model';
import { ContactSettings, TabStatus, UserSettings } from './UserSettings.model';

export const useUserSettings = () => {
	const {userId} = useAuthenticationDataContext();
	const {get, put} = useFetchWrapper();
	const [currentUser, setCurrentUser] = useState<CurrentUserResponse>();
	const [contactOptions, setContactOptions] = useState<ContactSettings>();
	const [editEmail, setEditEmail] = useState(false);
	const [email, setEmail] = useState<string>();
	const [showPasswordPopup, setShowPasswordPopup] = useState(false);
	const [tabStatus, setTabStatus] = useState<TabStatus>(TabStatus.Loading);
	const [isInvalidEmail, setIsInvalidEmail] = useState<boolean>(false);
	const { email: userEmail } = useAuthenticationDataContext();
	
	useEffect(() => {
		getCurrentUser();
		getSettings();

		setTabStatus(TabStatus.Loaded);
	}, []);

	useEffect(() => {
		validateEmail();
	}, [email]);

	const getCurrentUser = async () => {
		const response: HttpResponse<CurrentUserResponse> = await get(
			`/user/profile/${userId}`
		);
		if (response.parsedBody) {
			const user = response.parsedBody;
			setCurrentUser(user);
		}
	};

	const getSettings = async () => {
		const response: HttpResponse<UserSettings> = await get(`/user/settings`);
		if (response.parsedBody) {
			const {email, includeInNetwork, includeInSearch} = response.parsedBody;

			setContactOptions({includeInNetwork, includeInSearch});
			setEmail(email);
		}
	};

	const toggleEditEmail = () => {
		setEditEmail(!editEmail);
	};

	const validateEmail = () => {
		const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
		if (email && reg.test(email)) {
			setIsInvalidEmail(false);
		} else
			setIsInvalidEmail(true);
	};

	const togglePasswordPopup = () => {
		setShowPasswordPopup(!showPasswordPopup);
	};
	
	const setOldEmail = () => setEmail(userEmail);

	const updateEmail = async () => {
		await put('/user/settings/email', { email });
	};

	const updateSettings = async (contactSettings: ContactSettings) => {
		setContactOptions(contactSettings);
		const response = await put('/user/settings', contactSettings);
		if (response) getSettings();
	};

	return {
		setEmail,
		setOldEmail,
		state: { contactOptions, currentUser ,editEmail, email, isInvalidEmail, showPasswordPopup, tabStatus },
		toggleEditEmail,
		togglePasswordPopup,
		updateEmail,
		updateSettings,
		validateEmail
	};
};